import React from 'react'
import styled from 'styled-components';

const ContactItemStyled = styled.div`
    padding:1.5rem 1.8rem;
    background-color: var(--background-dark-grey);
    display: flex;
    align-items: center;
    &:not(:last-child){
        margin-bottom: 2.5rem;
    }
    .left-content{
        padding: 1.2rem;
        border: 1px solid var(--border-color);
        font-size: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 1.5rem;
        svg{
            font-size: 2.3rem;
        }
    }
    .right-content{
        h6{
            color: var(--white-color);
            font-size: 1.2rem;
            padding-bottom: .6rem;
        }
        p{
            padding: .1rem 0;
        }
    }
`;

const ContactItem = ({ title, icon, cont }) => {
    const start_cont = cont.slice(0, 14)
    const end_cont = cont.slice(14)
    const new_cont = <label>{start_cont}<br />{end_cont}</label>
    const screen_width = window.screen.availWidth

    return (
        <ContactItemStyled>
            <div className="left-content">
                {icon}
            </div>
            <div className="right-content">
                <h6>{title}</h6>
                <p>{cont.length > 12 && screen_width < 600 ? new_cont : cont}</p>
            </div>
        </ContactItemStyled>
    )
}
export default ContactItem